export default "__VITE_ASSET__DoHMWBf9__"